import { Signal } from "@lit-labs/signals";
import type { CoPromotionCreator, ICoPromotionSearchState } from "./types";

export class CoPromotionSearchState implements ICoPromotionSearchState {
  readonly creators = new Signal.State<CoPromotionCreator[]>([]);
  readonly loading = new Signal.State<boolean>(false);
}
